import React, { useState } from 'react';
import { Button, Grid, TextField, Typography } from '@mui/material';
import { AddExternalLead } from 'src/services/projectDetailService';

const ExternalAddForm = ({
  getData,
  setSnackBarMessage,
  setSnackbarSeverity,
  setSnackBarOpen,
  toggle
}) => {
  const [leadName, setLeadName] = useState('');
  const [leadNameError, setLeadNameError] = useState('');

  const onClick = () => {
    if (leadName === '' || leadName.trim().length < 1) {
      setLeadNameError('Lead name required');
    } else {
      const body = {
        name: leadName
      };
      AddExternalLead(body)
        .then(() => {
          setSnackBarMessage('You’ve added a external lead successfully.');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          getData();
          toggle();
        })
        .catch(() => {
          setSnackBarMessage('Unable to add external lead.');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          toggle();
        });
    }
  };

  return (
    <Grid container sx={{ p: 2 }} display="flex" justifyContent={`center`}>
      <Grid display="flex" flexDirection="column">
        <Typography
          style={{
            fontSize: '14px',
            marginBottom: '0.5rem',
            textAlign: 'center'
          }}
          variant="h4"
          component="h4"
        >
          Create External Lead
        </Typography>
        <TextField
          id="leadName"
          size="small"
          variant="outlined"
          inputProps={{
            max: 100,
            min: 0,
            style: {
              fontSize: '11px'
            }
          }}
          placeholder="Enter external lead name"
          value={leadName}
          onChange={(e) => {
            if (e.target.value.length < 25) {
              setLeadName(e.target.value);
            }
          }}
        />
        <Typography
          style={{
            paddingLeft: 15,
            paddingRight: 15,
            fontSize: '11px',
            textTransform: 'capitalize'
          }}
          color="red"
        >
          {leadNameError}
        </Typography>
        <Button
          id="btn-onClick"
          sx={{
            mt: 2,
            width: '10%',
            fontSize: '13px',
            fontWeight: 'normal',
            background: '#0069E4',
            ml: 'auto',
            mr: 'auto'
          }}
          variant="contained"
          type="button"
          onClick={() => onClick()}
        >
          Create
        </Button>
      </Grid>
    </Grid>
  );
};

export default ExternalAddForm;
